













































































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { studentBind } from '@/api/admin'

@Component
export default class Bindingcreat extends ViewBase {
  @Prop({ type: Object, default: () => ({}) }) item!: object
  @Prop({ type: Boolean, default: true }) visible!: boolean
  @Prop({ type: Number, default: 0 }) classId!: number

  labelCol = { span: 24 }
  wrapperCol = { span: 24 }
  lang = {}
  sitem = {}
  isEdit = false
  school = ''
  form = {}
  svisible = false
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  created() {
    this.school = JSON.parse(localStorage.school).school_key
    this.lang = this.i18n.vBinding
    this.form = this.$form.createForm(this)
    const lang: any = this.lang
  }

  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
    if (visible) {
      const item: any = Object.assign({}, this.item)

      this.isEdit = item.id > 0
      this.sitem = item
    }
  }
  @Watch('item')
  watchItem(item: any) {
    const item2: any = Object.assign({}, item)
    this.isEdit = item2.id > 0
    this.sitem = item2
    // this.sitem = this.item
    // console.log(this.item, this.subjectList, this.phaseList)
  }
  // onOk() {
  //   this.hide()
  // }
  // onCancel() {
  //   this.hide()
  // }
  onCancel() {
    const form: any = this.form
    form.resetFields()
    this.$emit('onCancel')
  }
  handleSubmit(e: any) {
    e.preventDefault()
    // console.log('tijiao')
    const form: any = this.form
    const item: any = this.item
    form.validateFieldsAndScroll((err: any, vals: any) => {
      if (!err) {
        // console.log('Received values of form: ', vals)

        const pdata = {
          class_id: this.classId,
          cid: vals.id,
          name: vals.name
        }
        this.onOk(pdata)
      }
    })
  }
  async onOk(pdata: any) {
    try {
      const res = await studentBind(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      const form: any = this.form
      form.resetFields()
      this.$emit('onOk')
    } catch (ex) {
      this.handleError(ex)
    }
  }
  // onOk() {
  //   if (!this.sname) {
  //     this.$message.error(this.tip1)
  //   } else {
  //     this.$emit('onOk', this.sname)
  //     this.sname = ''
  //   }
  // }
  // onCancel() {
  //   this.svisible = false
  //   this.$emit('onCancel')
  // }
}
